"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.attachSlotToInvitationResponseSchema = exports.attachSlotToInvitationBodySchema = void 0;
const zod_1 = require("zod");
exports.attachSlotToInvitationBodySchema = zod_1.z.object({
    slotId: zod_1.z.string().uuid(),
    officeId: zod_1.z.string().uuid(),
});
exports.attachSlotToInvitationResponseSchema = zod_1.z.object({
    success: zod_1.z.boolean(),
});
